import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {SettlementEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit} from "@tabler/icons-react";

export type SettlementAction = "EDIT"

export type SettlementActionMenuDropdownProps = {
  settlement: SettlementEntity
  onActionClick?: (action: SettlementAction) => void
}

export const SettlementActionMenuDropdown = (props: SettlementActionMenuDropdownProps) => {
  const {settlement, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<SettlementAction> = useMemo(() => {
    const actions = new Set<SettlementAction>()
    if (hasAccess("settlement_edit")) {
      actions.add("EDIT")
    }
    return actions
  }, [settlement, hasAccess])

  const _onActionClick = useCallback((action: SettlementAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
    </>
  )
}
